import { colors } from './_/colors-16fd59b8.js';
import theme$1 from './baseTheme.js';
let theme = {
    ...theme$1,
    colors
};
export { theme as default };
//# sourceMappingURL=defaultTheme.js.map
